import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import socket from "../../../services/socket";

import {
    Bell,
    Globe,
    MapPin,
    Lock,
    Shield,
    FileText,
    CircleHelp,
    Info,
    ChevronRight,
    Moon,
    LogOut,
    Power,
    UserCircle
} from "lucide-react";

import "./DeliverySettings.css";

function DeliverySettings() {

    const navigate = useNavigate();

    const [partner, setPartner] = useState(null);

    const [online, setOnline] = useState(false);

    // ==========================================
    // Fetch Profile
    // ==========================================

    useEffect(() => {

        fetchProfile();

    }, []);

    const fetchProfile = async () => {

        try {

            const response = await API.get("/delivery/profile");

            if (response.data.success) {

                setPartner(response.data.deliveryPartner);

                setOnline(
                    response.data.deliveryPartner.work.online
                );

            }

        }

        catch (error) {

            console.log(error);

        }

    };

    // ==========================================
    // Toggle Online
    // ==========================================

    const toggleOnline = async () => {

        try {

            const response = await API.patch(
                "/delivery/online",
                {
                    online: !online
                }
            );

            if (response.data.success) {

                setOnline(!online);

            }

        }

        catch (error) {

            console.log(error);

        }

    };

    // ==========================================
    // Logout
    // ==========================================

    const logout = () => {

        const confirmLogout = window.confirm(
            "Are you sure you want to logout?"
        );

        if (!confirmLogout) return;

        socket.disconnect();

        localStorage.removeItem("token");

        localStorage.removeItem("user");

        navigate("/login");

    };

    // ==========================================
    // Settings
    // ==========================================

    const settings = [

        {
            title: "Notifications",
            subtitle: "Manage notification preferences",
            icon: <Bell size={22} />,
            route: "/delivery/notification-settings",
        },

        {
            title: "Dark Mode",
            subtitle: "Appearance settings",
            icon: <Moon size={22} />,
            route: "/delivery/theme",
        },

        {
            title: "Language",
            subtitle: "Choose your preferred language",
            icon: <Globe size={22} />,
            route: "/delivery/language",
        },

        {
            title: "Location Permission",
            subtitle: "GPS & Location Access",
            icon: <MapPin size={22} />,
            route: "/delivery/location",
        },

        {
            title: "Privacy & Security",
            subtitle: "Manage account security",
            icon: <Shield size={22} />,
            route: "/delivery/privacy",
        },

        {
            title: "Change Password",
            subtitle: "Update your password",
            icon: <Lock size={22} />,
            route: "/delivery/change-password",
        },

        {
            title: "Terms & Conditions",
            subtitle: "Read HomeFoods Terms",
            icon: <FileText size={22} />,
            route: "/delivery/terms",
        },

        {
            title: "Help & Support",
            subtitle: "Need help?",
            icon: <CircleHelp size={22} />,
            route: "/delivery/support",
        },

        {
            title: "About HomeFoods",
            subtitle: "Version & App Information",
            icon: <Info size={22} />,
            route: "/delivery/about",
        }

    ];

    return (

        <div className="delivery-settings-page">

            {/* Header */}

            <div className="settings-header">

                <h1>

                    Settings

                </h1>

                <p>

                    Customize your delivery experience

                </p>

            </div>

            {/* Profile */}

            <div className="profile-card">

                <div className="profile-left">

                    <UserCircle size={60} />

                    <div>

                        <h2>

                            {
                                partner?.userId?.name ||
                                "Delivery Partner"
                            }

                        </h2>

                        <p>

                            {
                                partner?.userId?.phone ||
                                ""
                            }

                        </p>

                    </div>

                </div>

            </div>

            {/* Online */}

            <div className="setting-item">

                <div className="setting-left">

                    <div className="setting-icon">

                        <Power size={22} />

                    </div>

                    <div>

                        <h3>

                            Online Status

                        </h3>

                        <p>

                            {
                                online
                                    ? "Available for delivery"
                                    : "Offline"
                            }

                        </p>

                    </div>

                </div>

                <label className="switch">

                    <input

                        type="checkbox"

                        checked={online}

                        onChange={toggleOnline}

                    />

                    <span className="slider"></span>

                </label>

            </div>

            {/* Settings */}

            <div className="settings-list">

                {

                    settings.map((item, index) => (

                        <div

                            key={index}

                            className="setting-item"

                            onClick={() =>
                                navigate(item.route)
                            }

                        >

                            <div className="setting-left">

                                <div className="setting-icon">

                                    {item.icon}

                                </div>

                                <div>

                                    <h3>

                                        {item.title}

                                    </h3>

                                    <p>

                                        {item.subtitle}

                                    </p>

                                </div>

                            </div>

                            <ChevronRight size={20} />

                        </div>

                    ))

                }

            </div>

            {/* Logout */}

            <button

                className="logout-button"

                onClick={logout}

            >

                <LogOut size={20} />

                Logout

            </button>

        </div>

    );

}

export default DeliverySettings;